export default __webpack_public_path__ + "static/media/memorabilia_dark.81b8ac1f.png";